/**
 * 표시 포맷 유틸(워크스페이스 utils/format.ts 이식) — 숫자·금액·기간 표기의 SSoT.
 */
import { formatWon } from '@/lib/currency';

/**
 * 사업 예산(억원 단위 숫자 — 서버 계약) → '1,200억원'. 값이 없으면 `empty`(기본 '—') — 0 으로 보이면 오독이라 비워 둔다.
 */
export function formatBudgetEok(eok: number | null | undefined, empty = '—'): string {
  return eok == null ? empty : `${formatWon(eok)}억원`;
}

/** 숫자 → 천단위 문자열. null 은 '—'. */
export function formatNumber(value: number | null | undefined): string {
  return value == null ? '—' : formatWon(value);
}

/** 빈 값 → '—' 대체 표시(테이블·Descriptions 공용). */
export function orDash(value: string | number | null | undefined): string {
  return value == null || value === '' ? '—' : String(value);
}

/** 재생 시간(초) → '1:21'·'1:02:03'. null 은 빈 문자열(배지를 숨긴다). */
export function formatClock(totalSec: number | null | undefined): string {
  if (totalSec == null || totalSec < 0) return '';
  const s = Math.round(totalSec);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${sec}` : `${m}:${sec}`;
}
